import { MerchantForm } from "components/forms/MerchantForm"
import { useTranslation } from "react-i18next"
import { MerchantData } from "types"
import { BaseHeaderLayout, Box, ContentLayout, Link } from "@strapi/design-system"
import { ArrowLeft } from "@strapi/icons"
import { useEffect, useState } from "react"
import { useMerchantQuery, useSaveMerchantMutation } from "hooks/query/useMerchantQuery.ts"
import { useCurrentId } from "hooks/useCurrentId.ts"

interface MerchantPageProps {
  add?: boolean
}

export const MerchantPage = ({ add }: MerchantPageProps) => {
  const { t } = useTranslation()
  const merchantId = useCurrentId()
  const { data: merchantData, isLoading } = useMerchantQuery(merchantId)

  const [merchant, setMerchant] = useState<MerchantData>({
    id: "",
    name: "",
    email: "",
    domain: "",
    planId: "",
    cognitoSub: "",
    description: "",
    brandsIds: [],
  })

  const saveMerchantMutation = useSaveMerchantMutation(merchantId)

  useEffect(() => {
    if (merchantData) setMerchant(merchantData)
  }, [merchantData])

  const handleSave = async () => {
    saveMerchantMutation.mutate(merchant)
  }

  return (
    <Box>
      <BaseHeaderLayout
        title={`${add ? t("merchantPage.add") : t("merchantPage.edit")} ${t("merchantPage.title")}`}
        as="h1"
        navigationAction={
          <Link startIcon={<ArrowLeft />} to={`/merchants`}>
            {t("merchantPage.backToMerchants")}
          </Link>
        }
      />
      <ContentLayout>
        <MerchantForm
          merchant={merchant}
          onChange={setMerchant}
          handleSave={handleSave}
          loading={isLoading || saveMerchantMutation.isPending}
        />
      </ContentLayout>
    </Box>
  )
}
